<template>
    <div>
        <NavigationReceiver currentQuestion="1"></NavigationReceiver>
        <section class="pt-5">
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-3">
                        <div class="alert alert-warning d-flex mb-2" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Kijk niet langer dan een week terug en vul dan de vragen zo goed mogelijk in.</span>
                        </div>
                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Activiteiten die u wél als zwaar ervaart en die niet in de lijst staan, kunt u aan het eind toevoegen.</span>
                        </div>
                    </div>
                    <div class="col-xl-6 px-5 text-center">
                        <div class="row justify-content-center mb-4">
                            <div class="col-xl-3 col-4">
                                <img src="/img/questions/vraag1.png" class="img-fluid">
                            </div>
                        </div>
                        <h2 class="mb-4">{{ QuestionRepository.getQuestionValueById(1.1) }}</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12 col-12 text-center">
                                <RadioField :error="error" :options="[{
                                        value: 'ja',
                                        title: 'Ja'
                                    }, {
                                        value: 'nee',
                                        title: 'Nee'
                                    }]" id="1.1"></RadioField>
                                <transition name="fade-in-up">
                                    <div v-if="showFields()">
                                        <TextareaField :placeholder="QuestionRepository.getQuestionValueById(1.2)" id="1.2" :title="QuestionRepository.getQuestionValueById(1.2)"></TextareaField>
                                        <SelectField id="1.3" :options="[{
                                            value: 'Minder dan 12 kg',
                                            title: 'Minder dan 12 kg'
                                        }, {
                                            value: '12 - 23 kg',
                                            title: '12 - 23 kg'
                                        }, {
                                            value: 'Meer dan 23 kg',
                                            title: 'Meer dan 23 kg'
                                        }]" :title="QuestionRepository.getQuestionValueById(1.3)">
                                        </SelectField>
                                        <SelectField id="1.4" :options="[{
                                            value: 'Meer dan 12 keer',
                                            title: 'Meer dan 12 keer'
                                        }, {
                                            value: 'Minder dan 12 keer',
                                            title: 'Minder dan 12 keer'
                                        }]" :title="QuestionRepository.getQuestionValueById(1.4)"></SelectField>
                                    </div>
                                </transition>

                                <div class="text-center">
                                    <button class="btn btn-primary mb-3" @click="nextStep($event)">Volgende vraag</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RadioField from "../../../includes/RadioField";
import TextareaField from "../../../includes/TextareaField";
import SelectField from "../../../includes/SelectField";
import RecipientService from "../../../../services/RecipientService";
import defaultMethods from "./defaultMethods";
import defaultData from "./defaultData";

export default {
    name:       'StepOne',
    components: { SelectField, TextareaField, RadioField, NavigationReceiver },
    data() {
        return {
            ... defaultData,
            nextStepSlug: 'stap-2',
            showFieldsOn: '1.1',
            error:        false
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next, true);
    },
    methods: {
        ... defaultMethods
    }
}
</script>
